/* eslint-disable camelcase */

export function spViewItemList(items) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'sp_view_item_list',
        ecommerce: {
            item_list_name: items[0].itemCategoryParent,
            items: items.map(({ itemBrand, itemCategoryChild, itemCategoryParent, itemId, itemName, itemPrice }) => ({
                item_name: itemName,
                item_id: itemId,
                item_brand: itemBrand,
                item_parent_reporting_category: itemCategoryParent,
                item_child_reporting_category: itemCategoryChild,
                price: itemPrice
            }))
        }
    });
}